import React from "react";
import { Table, Tag } from "antd";
import { useComputerRefine } from "hook/base/computer/useComputerAction";
import { getTime } from "util/time.function";
import TableAction from "./table_action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const MachineTable = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useComputerRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Tạo lúc",
      dataIndex: "createAt",
      key: "createAt",
      render: (value) => renderTimer(value),
      sorter: (a, b) => a.createAt - b.createAt,
    },
    {
      title: "Triển khai lúc",
      dataIndex: "operationAt",
      key: "operationAt",
      render: (value) => renderTimer(value),
      sorter: (a, b) => a.operationAt - b.operationAt,
    },
    {
      title: "Xử lý lúc",
      dataIndex: "processingAt",
      key: "processingAt",
      render: (value) => renderTimer(value),
      sorter: (a, b) => a.processingAt - b.processingAt,
    },
    {
      title: "Tắt lúc",
      dataIndex: "sleepAt",
      key: "sleepAt",
      render: (value) => renderTimer(value),
      sorter: (a, b) => a.processingAt - b.processingAt,
    },
    {
      title: "Tên worker",
      dataIndex: "id",
      key: "id",
      render: (value) => <Tag>{value}</Tag>,
    },
    {
      title: "Image Family",
      dataIndex: "imageFamily",
      key: "imageFamily",
    },
    {
      title: "Image Project",
      dataIndex: "imageProject",
      key: "imageProject",
    },
    {
      title: "Machine",
      dataIndex: "machine",
      key: "machine",
    },
    {
      title: "operation",
      dataIndex: "operation",
      key: "operation",
    },
    {
      title: "status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "#",
      dataIndex: "#",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => <TableAction data={record} />,
    },
  ];

  const renderTimer = (value) => {
    const label = getTime(value, "YYYY-MM-DD HH:mm:ss");
    return <span style={{ fontSize: 10 }}>{label}</span>;
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Table
      rowKey={"id"}
      bordered
      size="middle"
      columns={columns}
      dataSource={data}
      loading={data === null}
    />
  );
};
export default MachineTable;
